<div id="shared-modal-container-header">
  <div>{{ getTitle }}</div>
  @if (isCloseIconVisible) {
    <div>
      <app-display-icon
        (click)="onCloseModal()"
        [border]="getCloseIcon.border"
        [icon]="getCloseIcon.icon"
        [tooltip]="getCloseIcon.tooltip">
      </app-display-icon>
    </div>
  }
</div>
